import { Dialog, DialogContent, makeStyles } from "@material-ui/core";
import React from "react";
import { DialogTitle, Transition } from "../../../../utils/DialogTitle";
import { Create } from "../Administracion/formCreateAño";
import theme from "../../../../app/config/themaConfig";


const useStyles = makeStyles((theme) => ({
    title: {
        fontSize: '20px',
        backgroundColor: 'white',
        color: '#2196F3',
        padding: '16px',
        display: 'flex',
        justifyContent: 'Center',
        alignItems: 'center',
        fontWeight: 'bold'
    },
}));


export const ModalAños = ({ busqueda, rowsPerPage, setopenMondal, isOpen, isEdit, data, reload, editUser }) => {
    const classes = useStyles();
    const clearData = () => {
        setopenMondal(false)

    }

    const primaryColor = theme.palette.primary.main;

    return (
        <>
            <div>
                <Dialog
                    onClose={(e) => { clearData() }}
                    aria-labelledby="customized-dialog-title"
                    open={isOpen}
                    TransitionComponent={Transition}
                    keepMounted
                    style={{ maxHeight: "500%" }}
                    fullWidth={true}
                    maxWidth="sm"
                >
                    <DialogTitle id="customized-dialog-title" onClose={(e) => { clearData() }}className={classes.title} style={{color:primaryColor}} >
                        { `Crear Año`}
                    </DialogTitle>
                    <DialogContent style={{ paddingBottom: '30px' }}>
                        {
                            
                                (<Create reload={reload} clearData={clearData} />)
                        }
                    </DialogContent>
                </Dialog>
            </div>
        </>
    );
}